module.exports = __webpack_public_path__ + "static/media/solo20.752cf449.JPG";